// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JoinBlock__container-f3a39a {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.JoinBlock__content-fc67c9 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
}

.JoinBlock__title-f61466 {
  color: var(--base-110);
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
}

.JoinBlock__sub-title-d85a85 {
  color: var(--base-80);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  text-align: center;
}

.JoinBlock__buttons-eb248e {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.JoinBlock__joinGuestButton-eab2c4,
.JoinBlock__signButton-ddb7de {
  width: 100%;
}

.JoinBlock__logo-ebd615 {
  margin-bottom: 24px;
}

.JoinBlock__logoShow-d086ce {
  display: none;
}

@media (max-width: 428px) {
  .JoinBlock__container-f3a39a {
    flex-grow: 1;
  }
  .JoinBlock__content-fc67c9 {
    justify-content: center;
    flex-grow: 1;
  }
  .JoinBlock__logoShow-d086ce {
    display: inline-block;
    width: 80px;
  }
}`, "",{"version":3,"sources":["webpack://./src/unauthorized/CallInvitation/JoinBlock/JoinBlock.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;EACA,2CAAA;AACF;;AAEA;EACE,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AACF;;AAEA;;EAEE,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE;IACE,YAAA;EACF;EAEA;IACE,uBAAA;IACA,YAAA;EAAF;EAGA;IACE,qBAAA;IACA,WAAA;EADF;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 24px;\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n}\n\n.sub-title {\n  color: var(--base-80);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  text-align: center;\n}\n\n.buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.joinGuestButton,\n.signButton {\n  width: 100%;\n}\n\n.logo {\n  margin-bottom: 24px;\n}\n\n.logoShow {\n  display: none;\n}\n\n@media (max-width: 428px) {\n  .container {\n    flex-grow: 1;\n  }\n\n  .content {\n    justify-content: center;\n    flex-grow: 1;\n  }\n\n  .logoShow {\n    display: inline-block;\n    width: 80px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `JoinBlock__container-f3a39a`,
	"content": `JoinBlock__content-fc67c9`,
	"title": `JoinBlock__title-f61466`,
	"sub-title": `JoinBlock__sub-title-d85a85`,
	"subTitle": `JoinBlock__sub-title-d85a85`,
	"buttons": `JoinBlock__buttons-eb248e`,
	"joinGuestButton": `JoinBlock__joinGuestButton-eab2c4`,
	"signButton": `JoinBlock__signButton-ddb7de`,
	"logo": `JoinBlock__logo-ebd615`,
	"logoShow": `JoinBlock__logoShow-d086ce`
};
module.exports = ___CSS_LOADER_EXPORT___;
